import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-popup-hof" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "area" }
const _hoisted_6 = { class: "area" }
const _hoisted_7 = { class: "detail" }

import { ref, onMounted } from "vue";
// import usePopupHof from "@/composables/usePopupHof";


export default /*#__PURE__*/_defineComponent({
  props: ["isShow", "data"],
  setup(__props) {

const props = __props



// let { imgName, title, show, pos, className, type } = usePopupHof();

// onMounted(() => {
//   if (props.articleID) {
//     fetchContent()
//   }
// })

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.data.avatar2,
      class: "layout-popup-hof-img"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.data.name), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.data.area), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.data.keyword), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(__props.data.detail), 1)
    ])
  ], 512)), [
    [_vShow, __props.isShow]
  ])
}
}

})